import type { CollaboratorPortalAccess } from '../../../lib/services/collaboratorAuthService';
import { formatLastAccess } from './portalDateFormat';

export { formatLastAccess };

export const LANGUAGE_LABELS: Record<string, string> = { it: 'Italiano', en: 'English' };

const PERMISSION_SUMMARY: { key: keyof CollaboratorPortalAccess['permissions']; label: string }[] = [
  { key: 'view_assigned_tasks', label: 'task' },
  { key: 'add_comments', label: 'commenti' },
  { key: 'upload_attachments', label: 'allegati' },
  { key: 'log_time', label: 'tempo' }
];

// Solo la prima parola della frase risultante è maiuscola (es. "Task, commenti,
// allegati"), indipendentemente da quale permesso capiti per primo nell'elenco.
export function permissionsSummary(permissions: CollaboratorPortalAccess['permissions']): string {
  const active = PERMISSION_SUMMARY.filter((p) => permissions[p.key]).map((p) => p.label);
  if (active.length === 0) return 'Nessun permesso attivo';
  const joined = active.join(', ');
  return joined.charAt(0).toUpperCase() + joined.slice(1);
}
